import React, { useState } from "react";


interface SEOValueProps {
    title: string;
    description: string;
    image: string;
    url: string;
    type: 'website' | 'article';
    
}
interface SEOProps {
    props: SEOValueProps;
    
}
const SEO: React.FC<SEOProps> = ({props}) => {
  const { title, description, image,url, type = 'website'  } = props;
  const x = 'test';
  return (
    <>
        <title>{title}</title>
        <meta name="title" content="title" />
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content={type} />
        <meta property="fb:app_id" content="1857553351412119" />
    </>
  );
};

export default SEO;
